import React, { Fragment, useState } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import Footer from '../../../../components/footer'
import Head from '../../../../components/head';
import Listar from '../../../../components/auth/ouvidoria/esic'


function ListarRequisicoesScreen() {

    return (
        <Fragment>
            <Head titulo="Pedidos de acesso à informação cadastrados" />
            <HeaderLogged />
            <Container>
               <Listar />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default ListarRequisicoesScreen;